export default __webpack_public_path__ + "static/media/buildings_only.40e4d46e.svg";